module.exports = __webpack_public_path__ + "img/quality-fssc.25c5166a.png";